import { useEffect } from 'react';

import { useSession } from '@hooks/useSession';

import type { FhirResource } from '@models/fhir-resource';

import { useSetViewedStatus } from './api/extension';

export function useViewable(resources: FhirResource[] = []) {
  const [setViewedStatus] = useSetViewedStatus();
  const {
    state: { activeProfile, isClient },
  } = useSession();

  useEffect(() => {
    if (resources.length === 0) return;
    const filteredRecords = resources.filter((r) => r.id && !r.viewedStatus);
    async function fetch() {
      if (!activeProfile || !isClient) {
        return;
      }

      await Promise.all(
        filteredRecords.map(async (r) =>
          setViewedStatus({
            input: {
              resource: r.getResourceId(),
              viewed: true,
            },
          })
        )
      );
    }

    if (filteredRecords.length) {
      fetch();
    }

    // eslint-disable-next-line
  }, [resources.length]);
}
